module.exports = __webpack_public_path__ + "static/media/cunningman-civil-marine-ltd.bde2d08c.png";